import React, { useState, useEffect } from 'react';
import { Accordion, Card, Button, Form, Modal, ListGroup, Tabs, Tab,OverlayTrigger, Popover } from 'react-bootstrap'
import Select from 'react-select';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Moment from 'moment';
import { addDays, addYears, subYears } from 'date-fns'
import SHA256 from "crypto-js/sha256";
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-datepicker';
import { isEmpty, isNull, map } from 'lodash';
import ReactGA from "react-ga";
import InputMask from 'react-input-mask';
import Swal from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';

export default function BikeIns(props) {
    let query = new URLSearchParams(useLocation().search);
    const [key, setKey] = useState(query.get("paymentID") === null ? 'plan' : query.get("keyTab"));
    const [planInfo, setPlanInfo] = useState([]);
    const [addonsInfo, setAddonsInfo] = useState([]);
    const [ownerInfo, setOwnerInfo] = useState([]);
    const [sumInfo, setSumInfo] = useState([]);

    const [showRenewalModal, setShowRenewalModal] = useState(false);
    const [renewalInfo, setRenewalInfo] = useState({});
    const [loadRenewalPopup ,setLoadRenewalPopup] =  useState(false);
    

    useEffect(() => {
        // Use the referral prop as needed in the component
        
        }, [props.referral]);


    useEffect(() => {

        if(!isEmpty(props.renewalParam) && !isEmpty(props.renewalTag)) {
           
            if(loadRenewalPopup == true) {
                setShowRenewalModal(true);
            }
            
        }
        
    }, [props.renewalParam, props.renewalTag, loadRenewalPopup]);

    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white fw-bold">CyberGuard</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-12 col-md-10 px-0 shadow bg-white rounded">
                        <Tabs activeKey={key} variant="tabs"  onSelect={(k) => setKey(k)}>
                            <Tab eventKey="plan" title="Select Plan" disabled={true}>
                                <Plan setKey={setKey} setPlanInfo={setPlanInfo} sumInfo={sumInfo}  
                                renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo} setShowRenewalModal={setShowRenewalModal} showRenewalModal={showRenewalModal} renewalParam={props.renewalParam} renewalTag={props.renewalTag} setLoadRenewalPopup={setLoadRenewalPopup} loadRenewalPopup={loadRenewalPopup}/>
                            </Tab>
                            <Tab eventKey="owner" title="My Info" disabled={true}>
                                <Owner setKey={setKey} setOwnerInfo={setOwnerInfo} addonsInfo={addonsInfo} sumInfo={sumInfo} planInfo={planInfo} 
                                 renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo} />
                            </Tab>
                            <Tab eventKey="summary" title="Summary" disabled={true}>
                                <Summary setKey={setKey} ownerInfo={ownerInfo} addonsInfo={addonsInfo} sumInfo={sumInfo} planInfo={planInfo} referral={props.referral} 
                                renewalInfo={renewalInfo} setRenewalInfo={setRenewalInfo} />
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="col-md-1"></div>
                </div>
            </div>
        </section>
    );
}

function Plan(props) {
    const [planPremium, setPlanPremium] = useState({ })
    const [transactionData, setTransactionData] = useState([]);
    const [benefit, setBenefit] = useState({});
    const [sumInsured, setSumInsured] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pickPlan, setPickPlan] = useState("");

    const [tabBenefit, setTabBenefit] = useState("");

    const [selectedTab, setSelectedTab] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
            getPlanBenefits();
      }, []);
      
    const getPlan = (data) => {
        let sstAmount = parseFloat(data.premium) * parseFloat(process.env.MIX_SERVICE_CHARGE_RATE / 100);
        let stampDutyAmount = 10;
        let totalPayable =  parseFloat(data.premium) + parseFloat(sstAmount) + parseFloat(stampDutyAmount);

        setTransactionData({
            product: 'Personal Cyber Insurance',
            planId: data.id,
            planName: data.name,
            planPremium: data.premium,
            planSST : sstAmount,
            planStampDuty: stampDutyAmount,
            planTotalPayable: totalPayable,
        });

    };

    useEffect(() => {

        if(planPremium.length > 0 && benefit.length > 0)
        {
            axios.get('/api/get-sum-insured').then((response) => {
               let sumData = [];
                $.each(response.data, function (i, obj) {
                   $.each(obj, function (x, obj2) {
                        $.each(obj2, function (y, obj3) {
                            sumData['plan_'+x+'_benefit_'+y] = obj3   
                        });
                        
                   });
 
                });
               setSumInsured(sumData);
                Swal.close();
                props.setLoadRenewalPopup(true);

            }).catch((error) => {
            Swal.close();
                console.log(error);
            });
        } 
        
      }, [planPremium, benefit]);


    function getPlanBenefits() {
       
        const loadingSwal = Swal.fire({
            title: 'Please Wait...',
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
            },
            showConfirmButton: false // Remove the "OK" button
          });

          const fetchData = async () => {
            setLoading(true);
      
            const loadingSwal = Swal.fire({
              title: 'Please Wait...',
              allowOutsideClick: false,
              willOpen: () => {
                Swal.showLoading();
              },
              showConfirmButton: false // Remove the "OK" button
            });
           
            try {
              const response = await axios.get('/api/get-plan', {
                headers: {
                  "content-type": "application/json",
                }
              });

              setPlanPremium(response.data);

              setLoading(false);
            } catch (error) {
              console.log(error);
              // Handle errors accordingly
              Swal.close();
            }
          };
      
          fetchData();

        
        axios.get('/api/get-benefit').then((response) => {
            setBenefit(response.data);
          }).catch((error) => {
           
            console.log(error);
        });

    }

    function getSmallBenefitDetails(bnfId) {

        if($('.sm-bnf-'+bnfId).closest(".sm-main-point").next("div").hasClass('show')) {
           
            $('.sm-minus-'+bnfId).addClass('d-none')
            $('.sm-plus-'+bnfId).removeClass('d-none')

        }
        else {
           
            $('.sm-minus-'+bnfId).removeClass('d-none')
            $('.sm-plus-'+bnfId).addClass('d-none')
        }

    }

    function getBenefitDetails(bnfId)
    {

       if($('.bnf-'+bnfId).closest(".main-point").next("div").hasClass('show')) {
           
            $('.minus-'+bnfId).addClass('d-none')
            $('.plus-'+bnfId).removeClass('d-none')

           
        }
        else {
           
            $('.minus-'+bnfId).removeClass('d-none')
            $('.plus-'+bnfId).addClass('d-none')
        }

    }

    function onClickNext(e) {

        e.preventDefault();

        const form = e.currentTarget;
        if ((form.checkValidity() !== false)) {
		
            e.preventDefault();
            e.stopPropagation();

            props.setPlanInfo(transactionData);
            props.setKey("owner");
        }
    }

    function ShowRenewalPopup(props) {

        
        const [icNumber, setIcNumber] = useState('');
    
        function onClickNextValidate(e) {
            e.preventDefault();
            e.stopPropagation();

    
            axios.post('/api/validate-renewal-id', {
                icNumber: icNumber,
                renewalParam: props.renewalParam,
                renewalTag: props.renewalTag,
            }).then(function (response) {

                if(response.data.status == 'success') {

                    let transactionInfo = response.data.transaction_data;

                    props.setRenewalInfo(transactionInfo);
                    props.setShowRenewalModal(false);

                } else {

                     Swal.fire({
                        text: "The number you entered does not match the last 4 digits of the Owner's NRIC Number. Do you want to try again?",
                        type: "info",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: 'Yes',
                        cancelButtonText: "No",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then((result) => {	
                        if (result.value){
                           props.setShowRenewalModal(true);
                        } else {
                            props.setShowRenewalModal(false);
                        }
                    });
                }
                    
            })
    
        }
    
        return (
            <Modal show={props.showRenewalModal} onHide={() => props.setShowRenewalModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <div className="col-11 text-center">
                        <img src="../images/new-logo-02.png" className="img ms-5" width={120} />
                    </div>
                </Modal.Header>
                <Form onSubmit={(e) => { onClickNextValidate(e); }}>
                    <Modal.Body>
                        <div className="mb-3 row">
                            <label className="col col-form-label">Please key in the last <b>4 digit</b> of owner's NRIC number to continue.</label>
                            <div className="col-12">
                                <input type="text" className="form-control" placeholder="Last 4 Digit NRIC Number" required maxLength={4} value={icNumber} onChange={(e) => setIcNumber(e.target.value)} />
                                <small>Without spaces / dashes [-]</small>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="mb-3 row text-end">
                            <div className="col-12">
                                <Button type="submit" variant="success" block>Next</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>  


                     {/* For small screen    */}
                    <div class="row d-block d-lg-none">   
                    {planPremium.length > 0 ?
                    <>
                    {planPremium.map((plan, index) => (          
                        
                        <div class="col-12 mb-4">
                            <div class="card">
                            <div class="card-header bg-body-tertiary py-3">
                                <h5 className='text-center'>{plan.name}</h5>
                                    <div className='text-center'>
                                        Annual Premium
                                        <br></br>
                                        <span className='fw-bold h5 text-primary'>
                                        RM {(parseFloat(plan.premium)).toFixed(2)}
                                        </span> 
                                        /per year
                                    </div>

                                    <div className='text-center mb-3' style={{fontSize : "1rem"}}>
                                        <span className='fw-bold'>RM {(parseFloat(plan.premium)/365).toFixed(2)}</span>
                                        <span>&nbsp;/per day</span>
                                    </div>
                                    <div className='text-center'>Coverage</div>
                            </div>

                            <div class="card-body">
                                <ul class="list-group list-group-flush">

                                {benefit.length > 0 ?
                                    <>
                                    {benefit.map((bnf, benefitId) => (     
                                        <li class="list-group-item" style={{padding: "0.75rem 0rem"}}>
                                            <Accordion>
                                            
                                                <Accordion.Toggle as={Card.Text} eventKey='add-ons' title="Click for more details" className='sm-main-point ps-0 border-0 clickable' 
                                                role="button" onClick={(e) => {
                                                    getSmallBenefitDetails(bnf.id)  
                                                }}>
                                                    <div class="row">
                                                    <div class={('col-1')+" sm-bnf-"+bnf.id}>
                                                                    <i class={('fa fa-minus-circle text-primary d-none')+" sm-minus-"+bnf.id}></i>
                                                                        
                                                                    <i class={('fa fa-plus-circle text-primary ')+" sm-plus-"+bnf.id}></i>
                                                        </div>
                                                        <div class="col-10">
                                                        {bnf.name}
                                                        </div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey='add-ons'>
                                                    <Card.Text>
                                                        <div class="row">
                                                            <div class="col-1"></div>
                                                            <div class="col-10">
                                                                <small>
                                                                    {bnf.description}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    
                                                    </Card.Text>
                                                </Accordion.Collapse>
                                            </Accordion>
                                            
                                            <div class="row">
                                                <div class="col-1"></div>
                                                <div class="col-10">
                                                    <span className='fw-bold text-primary'>
                                                        {!isNaN(sumInsured['plan_'+plan.id+'_benefit_'+bnf.id]) ? 
                                                            <>
                                                            RM {parseFloat(sumInsured['plan_'+plan.id+'_benefit_'+bnf.id]).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                            
                                                            </>  
                                                        :
                                                            '-'
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                      ))}
                                      </>
                                  :
                                      <li>
                                          <td>No Benefits found</td>
                                      </li>
                                  }
                                    
                                </ul>
                            </div>

                            <div class="card-footer bg-body-tertiary py-3 d-grid">
                            
                                    <Button
                                        type="submit"
                                        //variant={pickPlan === "2" ? "primary" : "outline-primary"}
                                        variant="outline-primary"
                                        className="mb-3 mb-sm-0"
                                        block
                                        onClick={() => {getPlan(plan); setPickPlan(plan.id)}}
                                    >
                                        I Choose This
                                    </Button>
                                
                            </div>

                            </div>
                        </div>

                        ))}
                        </>

                        :
                        <div class="col-12 mb-4">
                            No Available Plan founds.
                        </div>
                        }

                    </div>

                    {/* For Big screen */}
                    <div className="table-responsive d-none d-lg-block">

                        <table className="table">
                            <thead className="thead-inverse">
                                <tr>
                                    <th style={{'width': '30%'}}></th>
                                    {planPremium.length > 0 ?
                                       <>
                                        {planPremium.map((plan, index) => ( 
                                            <th className="">   
                                                <h5 className='text-center'>{plan.name}</h5>
                                                    <div className='text-center'>
                                                        Annual Premium
                                                        <br></br>
                                                        <span className='fw-bold h5 text-primary'>RM {(parseFloat(plan.premium)).toFixed(2)}</span>
                                                        <span>&nbsp;/per year</span>
                                                       
                                                    </div>

                                                    <div className='text-center mb-3' style={{fontSize : "1rem"}}>
                                                        <span className='fw-bold'>RM {(parseFloat(plan.premium)/365).toFixed(2)}</span>
                                                        <span>&nbsp;/per day</span>
                                                     </div>


                                                    <div className='text-center'>Coverage</div>
                                                    </th>
                                        ))}
                                        </>
                                        
                                    :
                                        <th className="" colSpan={3}>
                                            No Available Plan founds.
                                        </th>
                                    }
                                </tr>
                            </thead>
                            <tbody>

                                {benefit.length > 0 ?
                                    <>
                                        {benefit.map((bnf, benefitId) => (     
                                        <tr>
                                            <td className="option">
                                            
                                                        <Accordion>
                                                            
                                                            <Accordion.Toggle as={Card.Text} eventKey='add-ons' title="Click for more details" className='main-point ps-0 border-0 clickable' 
                                                            role="button" onClick={(e) => {
                                                                  getBenefitDetails(bnf.id)  
                                                                   
                                                              }}>
                                                                <div class="row">
                                                                <div class={('col-1')+" bnf-"+bnf.id}>
                                                              
                                                                       
                                                                            <i class={('fa fa-minus-circle text-primary d-none')+" minus-"+bnf.id}></i>
                                                                        
                                                                            <i class={('fa fa-plus-circle text-primary ')+" plus-"+bnf.id}></i>     
                                                                        
                                                                    </div>
                                                                    <div class="col-10">
                                                                        {bnf.name}
                                                                    </div>
                                                                </div>
                                                            </Accordion.Toggle>
                                                            <Accordion.Collapse eventKey='add-ons'>
                                                                <Card.Text>
                                                                <div class="row">
                                                                    <div class="col-1"></div>
                                                                    <div class="col-10">
                                                                        <small>
                                                                            {bnf.description}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                                </Card.Text>
                                                            </Accordion.Collapse>

                                                        </Accordion>
                                                
                                            </td>

                                           
                                            {planPremium.length > 0 ?
                                                <>
                                                    {planPremium.map((plan) => ( 
                                                        
                                                        <td className="text-center">
                                                            <span className='fw-bold text-primary'>
                                                            {!isNaN(sumInsured['plan_'+plan.id+'_benefit_'+bnf.id]) ? 
                                                                <>
                                                                RM {parseFloat(sumInsured['plan_'+plan.id+'_benefit_'+bnf.id]).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                               
                                                                </>  
                                                            :
                                                                '-'
                                                            }
                                                            </span>
                                                        </td>
                                                        
                                                    ))}
                                                    </>
                                                    
                                                    :
                                                    <td className="text-center" colSpan={3}>
                                                        No Available Sum Insured founds.
                                                    </td>
                                            }
                                        </tr>
                                        ))}
                                    </>
                                :
                                    <tr>
                                        <td>No Benefits found</td>
                                    </tr>
                                }
                                
                            </tbody>

                            <tfoot class="thead-inverse">
                                <tr>
                                    <th class="w-25"></th>

                                    {planPremium.length > 0 ?
                                       <>
                                        {planPremium.map((plan, index) => ( 
                                             <th class="">
                                                <div className='card-footer' style={{backgroundColor: 'white', borderTop: '0'}}>
                                                    <Button
                                                        type="submit"
                                                        //variant={pickPlan === plan.id ? "primary" : "outline-primary"}
                                                        variant="outline-primary"
                                                        className="mb-3 mb-sm-0"
                                                        block
                                                        onClick={() => {getPlan(plan); setPickPlan(plan.id)}}
                                                    >
                                                        I Choose This
                                                    </Button>
                                                </div>
                                            </th>
                                        ))}
                                        </>
                                        
                                    :
                                        <th className="" colSpan={3}>
                                            No Available Plan founds.
                                        </th>
                                    }

                                </tr>
                            </tfoot>

                        </table>
                    </div>


                    <div className="mb-3 row mt-5 align-items-center">
                        <div className="col-12">
                            <a className="btn btn-info me-3" href="/Landing">Back</a>
                            {/* <Button type="button" variant="info" className="me-3" onClick={() => { props.setKey('Sum') }}>Back</Button> */}
                            {/* <Button type="submit">Continue</Button> */}
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>

                    
         <ShowRenewalPopup
                        showRenewalModal={props.showRenewalModal} setShowRenewalModal={props.setShowRenewalModal}
                        renewalParam={props.renewalParam}
                        renewalTag={props.renewalTag} 
                        renewalInfo={props.renewalInfo} setRenewalInfo={props.setRenewalInfo}
                    />
                </Card.Body>
            </Card>
        </Form>

    );
}

function Owner(props) {
    // const [ownerName, setOwnerName] = useState("");
    const [ownerContactNo, setOwnerContactNo] = useState("");
    const [ownerIC, setOwnerIC] = useState("");
    const [ownerEmailAdd, setOwnerEmailAdd] = useState("");
    const [ownerAddr1, setOwnerAddr1] = useState("");
    //const [ownerAddr2, setOwnerAddr2] = useState("");
    // [ownerPostcode, setOwnerPostcode] = useState("");
   // const [ownerstate, setOwnerState] = useState("");
    const [selectedValue, setSelectedValue] = useState('');
   // const [IDType, setIDType] = useState("");
    const [IDTypeList] = useState([
        { value: "NRIC Number", label: "NRIC Number" },
        { value: "Passport", label: "Passport" }
    ]);
    const [nationalities, setNationalities] = useState([]);
    //const [selectedNationality, setSelectedNationality] = useState(''); 
    // policyholder
    const [policyName, setPolicyName] = useState("");
    const [policyGender, setPolicyGender] = useState("");
    const [policyDOB, setPolicyDOB] = useState("");
    const [policyDOB1, setPolicyDOB1] = useState("");
    const [PolicyIDType, setPolicyIDType] = useState("MYS");
    const [policyIC, setPolicyIC] = useState("");
    const [selectedPolicyNationality, setSelectedPolicyNationality] = useState(''); 
    const [employmentLocation, setEmploymentLocation] = useState("Malaysia");

    const [occupation, setOccupation] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const [tinNo, setTinNo] = useState("");
    const [requireEinvoice, setRequireEinvoice] = useState("");
    const [einvoiceIndicatorList] = useState([
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" }
    ]);


    // const [RelationshipList] = useState([
    //     { value: "Parent", label: "Parent" },
    //     { value: "Legal Guardian", label: "Legal Guardian" }
    // ]);
   //const [RelationshipType, setRelationshipType] = useState("");
    const [GenderList] = useState([
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" }
    ]);

    const [inputPromo, setInputPromo] = useState('');
    const [discountAmount, setDiscountAmount] = useState(0);
    const [discountPercentage, setDiscountPercentage] = useState(0);
    const [checkpromo, setCheckpromo] = useState('');
    const [code, setCode] = useState('');

    const handleInputChange = (event) => {
        setInputPromo(event.target.value);
    };

    const handleButtonClick = () => {

        const loadingSwal = Swal.fire({
            title: 'Please Wait...',
            allowOutsideClick: false,
            willOpen: () => {
              Swal.showLoading();
            },
            showConfirmButton: false // Remove the "OK" button
          });
        // Perform Axios POST request
        axios.post('/api/promo', { code: inputPromo })
            .then(response => {
                
                if(response.data){
                    Swal.close();
                }
                if (response.data && response.data.id) {
                    const { discount_amount, code, discount_percentage } = response.data;

                    if (discount_amount !== null && discount_amount !== "") {
                        setDiscountAmount(discount_amount);
                        setCheckpromo("Fixed");
                       
                        
                    } else if (discount_percentage !== null && discount_percentage !== "") {
                        let amount = parseFloat(props.planInfo.planPremium) * parseFloat(discount_percentage)/100;
                        setDiscountAmount(amount);
                        setDiscountPercentage(discount_percentage);
                        setCheckpromo("Percentage");
                        
                       
                    }
    
                    setCode(code);
                   
                } else {
                    Swal.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'Promo Code is invalid.'
                    });
                    setInputPromo('');
                }
            })
            .catch(error => {
            console.error('POST Error:', error);
            // Handle the error as needed
            });
    };

    const isPromoApplied = discountAmount !== 0 && code;

    const recalculateTotal1 = () => {

        let total = 0;
        let basic =  props.planInfo.planPremium
        let service =  props.planInfo.planSST
        let stamp =   props.planInfo.planStampDuty
        if(checkpromo == "Fixed")
        {
            total = (parseFloat(basic) - parseFloat(discountAmount)) + parseFloat(service) + parseFloat(stamp);
           
        }else if(checkpromo == "Percentage"){
            const discountRate = parseFloat(discountPercentage) / 100; // Convert percentage to decimal
            const discountValue = parseFloat(basic) * discountRate; // Calculate discount value
            total = (parseFloat(basic) - discountValue) + parseFloat(service) + parseFloat(stamp);
           
        }else{
            total = parseFloat(basic) + parseFloat(service) + parseFloat(stamp);
        }
       
        return total;
    };

     useEffect(() => {

        if(!isEmpty(props.renewalInfo)) {

            console.log('Owner useEffect renewalInfo');

            //         "name": "test"
            // +"idNumber": "880909-09-0999"
            // +"dateOfBirth": "1988-09-09"
            // +"gender": "Male"
            // +"nationality": "Malaysia"
            // +"mobileNo": "0192223333"
            // +"email": "siowlee.chan@howdengroup.com"
            // +"address": "123"
            // +"occupation": "testet"
            // +"inception_date": "2024-08-23"
            // +"expiry_date": "2025-08-20"
            // +"tin_no": null
            // +"require_einvoice": null


            setPolicyName(props.renewalInfo.name);
            onGetBrithDateAndGender(props.renewalInfo.idNumber);
            setOwnerContactNo(props.renewalInfo.mobileNo);
            setEmailAddress(props.renewalInfo.email);
            setOwnerAddr1(props.renewalInfo.address);
            setOccupation(props.renewalInfo.occupation)

            
        }
       
       
    }, [props.renewalInfo]);

    useEffect(() => {
        if (PolicyIDType == "NRIC Number") {
            setSelectedPolicyNationality("MYS");
            setPolicyIC("");
        } else {
            setSelectedPolicyNationality("");
            setPolicyIC("");
        }
    }, [PolicyIDType]);

    useEffect(() => {
        // Fetch nationalities from Laravel API
        fetch('/api/nationalities')
            .then(response => response.json())
            .then(data => {
                // Format data to match react-select options structure
                const formattedData = data.map(nationality => ({
                    value: nationality.code,
                    label: nationality.country
                }));
                setNationalities(formattedData);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    // const handleSelectChange = (selectedOption) => {
	
    //     setSelectedNationality(selectedOption.value); // Store only the value
    // };

    const handleSelectChange1 = (selectedOption) => {
        setSelectedPolicyNationality(selectedOption.value); // Store only the value
    };

    // const handleChange = (event) => {
    //   setSelectedValue(event.target.value);
    // };

    const handleDateChange = (e) => {
        // Parse the input date string to the desired format (YYYY/MM/DD)
        const inputDate = e.target.value;
    
        // Assuming you have a calculateAge function available
        const age = calculateAge(inputDate);
    
        if (age !== null && age < 18) {
            // Display Swal error for age below 18
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Age of Insured must 18 years old and above.',
            });
            setPolicyDOB1('');
            setPolicyDOB('');
            return;
        }
    
        setPolicyDOB1(inputDate);
        const formattedDate = formatDate(inputDate);
        setPolicyDOB(formattedDate);
    };
    
    const formatDate = (dateString) => {
        // Assuming the input date format is 'YYYY-MM-DD'
        const [year, month, day] = dateString.split('-');
        return `${year}/${month}/${day}`;
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if(!isEmpty(inputPromo)) {
            handleButtonClick();
        }
    }, [props.planInfo]);

const onGetBrithDate = (e) => {
        const inputValue = e.target.value;

        setOwnerIC(e.target.value);
        //const givenDOB = props.sumInfo.dob;
        const enteredNRIC = e.target.value.replace(/-/g, ''); // Remove hyphens from entered NRIC
        const nricDOB = enteredNRIC.substring(0, 6); // Extract the first six digits as NRIC date of birth
        const lastDigit = parseInt(enteredNRIC.charAt(11), 10); // Extract the last digit
        const gender = lastDigit % 2 === 0 ? 'Female' : 'Male';

        // if (nricDOB.length === 6) {
        //     if (nricDOB !== givenDOB.substring(2).replace(/\//g, '')) {
        //         // If the NRIC date does not match the given date of birth
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'NRIC Date Mismatch',
        //             text: 'The NRIC date does not match the given date of birth.',
        //         });
        //         setOwnerIC("");
        //     } else {
        //         // Set the NRIC value if validation passes
        //         setOwnerIC(e.target.value);
        //     }
        // }
        // if (enteredNRIC.length === 12){
        //     if(gender != props.sumInfo.gender){
        //         // If the NRIC date does not match the given date of birth
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'NRIC Gender Mismatch',
        //             text: 'The NRIC gender does not match the given gender.',
        //         });
        //         setOwnerIC("");
        //     } else {
        //         // Set the NRIC value if validation passes
        //         setOwnerIC(e.target.value);
        //     }
        // }
    };

    function onGetBrithDateAndGender(value) {
        setPolicyIC(value);
        var ic = value;
    
        if (ic.match(/^(\d{2})(\d{2})(\d{2})-?\d{2}-?\d{4}$/)) {   
            let gender = parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 === 0 ? 'Female' : 'Male';
            setPolicyGender(gender);
    
            let dob = [];
            let date = new Date();
    
            // Extracting YYMMDD from the first 6 digits of NRIC
            for (var i = 0; i < 6; i += 2) {
                dob.push(parseInt(ic.substr(i, 2)));
            }
    
            if (dob[0] <= date.getFullYear().toString().slice(-2)) {
                dob[0] += 2000;
            } else {
                dob[0] += 1900;
            }
    
            // Creating a Date object with the adjusted month (subtracting 1)
            const formattedDOB = new Date(dob[0], dob[1] - 1, dob[2]);
    
            // Check if the age is below 18
            //const age = calculateAge(formattedDOB.toISOString().split('T')[0]);
            const age = calculateAge(formattedDOB);

            if (age < 18) {
                // Display Swal error for age below 18
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Age of Insured must 18 years old and above.',
                });
                setPolicyIC('');
                setPolicyGender('');
                setPolicyDOB1('');
                return;
            }
    
            // Format the date as 'YYYY-MM-DD' in the local time zone
            const offset = formattedDOB.getTimezoneOffset();
            formattedDOB.setMinutes(formattedDOB.getMinutes() - offset);
            const formattedDateString = formattedDOB.toISOString().split('T')[0];
            // Set policyDOB1 with the formatted date
            setPolicyDOB1(formattedDateString);
            const formattedDate = formatDate(formattedDateString);
          
            setPolicyDOB(formattedDate);
        } else {
            // setNationality('');
            setPolicyGender('');
            setPolicyDOB1('');
        }
    }

    function updateEinvoiceIndicator(value) {

        setRequireEinvoice(value);
        if(value == 'No') {
            setTinNo("");
        }
    }

    const calculateAge = (selectedDate) => {

       let age =  Moment().diff(Moment(selectedDate, "DD-MM-YYYY"), 'years');

        return age;
    }    

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            

                if (!policyGender) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Please select a Gender',
                    });
                    return false;
                }

                

           
            if(policyIC.length !== 14){
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please enter a valid NRIC Number.',
                });
                return; // Stop further execution
            }
           
            if(requireEinvoice == '') {
                Swal.fire({
                     icon: 'error',
                    title: 'Oops...',
                    text: 'Please select e-Invoice indicator.'
                });
    
                return false;
            }

            if(requireEinvoice == 'Yes') {

                if(isEmpty(tinNo)) {

                    Swal.fire({
                        icon: 'error',
                            title: 'Oops...',
                            text: 'Please enter TIN No.'
                        });
            
                    return false;
                }

             if(!isEmpty(tinNo) && tinNo.length < 10) {

                Swal.fire({
                   icon: 'error',
                    title: 'Oops...',
                        text: 'TIN No. must be between 10 and 14 characters. Please re-enter.'
                });
    
                return false;

            } 

            }           

          

            props.setOwnerInfo({
               // product: props.planInfo.product,
               // quote: props.planInfo.quote,
                plan: props.planInfo,
               // age: props.sumInfo.age,
               // ownerName: ownerName,
                //ownerIC: ownerIC,
              //  nationality: selectedNationality,
                ownerContactNo: ownerContactNo,
                ownerEmailAdd: emailAddress,
                ownerAddr1: ownerAddr1,
                //ownerAddr2: ownerAddr2,
               // ownerPostcode: ownerPostcode,
               // ownerstate: selectedValue,
               // dob: props.sumInfo.dob,
                //gender: props.sumInfo.gender,
                //diabetic: props.addonsInfo.diabetic,
               // early: props.addonsInfo.early,
                //height: props.sumInfo.height,
                //weight: props.sumInfo.weight,
                //bmi: props.sumInfo.bmi,
               // smoker: props.sumInfo.smoker,
               // sumInsured: props.planInfo.sumInsured,
                //amount: parseFloat(props.addonsInfo.amount).toFixed(2),
                policyName: policyName,
                policyIC: policyIC,
                policyDOB: policyDOB,
                policyNationality: selectedPolicyNationality,
                policyGender: policyGender,
                occupation: occupation,
                employmentLocation: employmentLocation,
                
                promo: code,
                promoAmount: discountAmount,
                discountPercentage: discountPercentage,
                discountAmount: recalculateTotal1(),

                tinNo: tinNo,
                requireEinvoice: requireEinvoice,
            });

            props.setKey("summary");
        }
    }

    const handlePostcodeChange = (e) => {
        const inputPostcode = e.target.value;
        const regex = /^[0-9]{0,5}$/; // Regex to allow only digits with a maximum length of 5
    
        if (regex.test(inputPostcode)) {
            setOwnerPostcode(inputPostcode);
        }
    };

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className='row'>
                       
                        <div className='col-md-5'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='text-center align-self-center'>
                                    
                                        <h5>Personal Cyber Insurance</h5>
                                        <h3>{props.planInfo.planName}</h3>
                                    </div>
                                   
                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-7">Premium per annum</label>
                                            <label className="col-5 text-end align-self-center">
                                                RM {parseFloat(props.planInfo.planPremium).toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Service Tax (8%)</label>
                                            <label className="col-5 text-end align-self-center">
                                                RM {parseFloat(props.planInfo.planSST).toFixed(2)}
                                            </label>
                                        </div>
                                        <div className="row align-items-center">
                                            <label className="col-7">Stamp Duty</label>
                                            <label className="col-5 text-end align-self-center">
                                                RM {parseFloat(props.planInfo.planStampDuty).toFixed(2)}
                                            </label>
                                        </div>


                                        {!isPromoApplied && (
                                        <div class="input-group">
                                            <div class="text-danger fw-bold">HAVE A PROMO CODE?</div> 
                                            <div class="text-sm">Key in now & Click  <span class="text-danger fw-bold">APPLY</span></div>
                                        </div>
                                        )}

                                        {isPromoApplied && (
                                            <div className="row align-items-center">
                                                <label className="col-12 col-md-7 text-danger">Promo {checkpromo === "Fixed" ? "" : `${discountPercentage}% off`} <br></br>({ code })</label>
                                                <label className="col-12 col-md-5 text-end align-self-center text-danger">
                                                {/* - {checkpromo === "Fixed" ? `RM ${discountAmount}` : `${discountAmount}%`} */}
                                                - RM {parseFloat(discountAmount).toFixed(2)}
                                                </label>
                                            </div>
                                        )}

                                        <div className="input-group mb-3">
                                            <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Insert promo code & click APPLY."
                                            aria-label="Promo"
                                            aria-describedby="basic-addon2"
                                            style={{
                                                borderRadius: '4rem 0 0 4rem', fontSize: '0.938rem'
                                            }}
                                            value={inputPromo}
                                            onChange={handleInputChange}
                                            disabled={isPromoApplied}
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className={`btn ${isPromoApplied ? 'btn-success' : 'btn-primary'}`}
                                                    type="button"
                                                    onClick={handleButtonClick}
                                                    disabled={isPromoApplied}
                                                    style={{
                                                        borderRadius: '0 4rem 4rem 0', fontSize: '0.938rem'
                                                    }}
                                                >
                                                    {isPromoApplied ? 'APPLIED' : 'APPLY'}
                                                </button>
                                            </div>
                                        </div>
                                       

                                        <hr></hr>
                                        <div className="row align-items-center">
                                            <label className="col-12 col-lg-7 fw-bold">Total Annual Premium Payable</label>
                                            
                                                {code === "" ? 
                                                <label className="col-12 col-lg-5 text-end h5 text-primary fw-bold align-self-center">
                                                    RM {parseFloat(props.planInfo.planTotalPayable).toFixed(2)}
                                                </label>
                                                :
                                                <label className="col-12 col-lg-5 text-end align-self-center">
                                                    <span className='h5 text-primary fw-bold'>RM {recalculateTotal1().toFixed(2)}</span> <br></br>
                                                    <span style={{ textDecoration: 'line-through' }}>  RM {parseFloat(props.planInfo.planTotalPayable).toFixed(2)}</span>
                                                </label>
                                                }
                                               
                                           
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-7'>
                            <div className="mb-3 row">
                                <h5 className="col-sm-12">Insured's Personal Details</h5>
                            </div>
                           
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Full Name <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={policyName} onChange={(e) => setPolicyName(e.target.value)} />
                                </div>
                            </div>
                           
                          
                            <div className="mb-3 row">
                                <label className="col-md-5 col-form-label">
                                    NRIC Number <span className='text-danger'>*</span>
                                </label>
                                <div className="col-md-7">
                                    <InputMask
                                        mask="999999-99-9999"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        required
                                        value={policyIC}
                                        onChange={(e) => onGetBrithDateAndGender(e.target.value)}
                                    />
                                </div>
                            </div>
                          
                            <div className="mb-3 row">
                                <label className="col-md-5 col-form-label">Date of Birth <span className='text-danger'>*</span>
                                </label>
                                <div className="col-md-7">
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        value={policyDOB1}
                                        onChange={handleDateChange}
                                    />
                                </div>
                            </div>
                          
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Gender <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select
                                        styles={{
                                            control: provided => ({ ...provided, borderRadius: "2rem" })
                                        }}
                                        placeholder="Select Gender"
                                        required
                                        value={GenderList.find(obj => obj.label === policyGender)}
                                        options={GenderList}
                                        onChange={(e) => { setPolicyGender(e.label); }}
                                    />
                                </div>
                            </div> 
                           
                            
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Mobile/ Home Telephone No. <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={ownerContactNo}
                                    onChange={(e) => setOwnerContactNo(e.target.value)}
                                    pattern="\d{10,}" // Specifies minimum 10 digits using pattern attribute
                                    title="Please enter at least 10 digits"
                                    maxLength="11"
                                    placeholder="012xxxxxxxx"
                                />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Email Address <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="email" className="form-control" required value={emailAddress}  onChange={(e) => setEmailAddress(e.target.value)} />
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Address <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={ownerAddr1} onChange={(e) => setOwnerAddr1(e.target.value)} />
                                </div>
                            </div>

                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Occupation <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <input type="text" className="form-control" required value={occupation} onChange={(e) => setOccupation(e.target.value)} />
                                </div>
                            </div>

                            <div className="mb-3 row">
                                <label className="col-sm-5 col-form-label">Employment Location</label>
                                <div className="col-12 col-sm-7 btn-group" role="group" aria-label="Basic radio toggle button group">

                                    <input type="radio" class="btn-check" name="location" id="location1" checked={employmentLocation === "Malaysia" ? 'checked' : ''} value="Malaysia" onClick={(e) => setEmploymentLocation(e.target.value)} selected={employmentLocation === 'Malaysia'} />
                                    <label for="location1" className={employmentLocation === "Malaysia" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                        Malaysia
                                    </label>
                                    {/* <label className={employmentLocation === "Overseas" ? 'btn btn-primary active' : 'btn btn-outline-primary'}>
                                        <input type="radio" name="location" value="Overseas" onClick={(e) => setEmploymentLocation(e.target.value)} selected={employmentLocation === 'Overseas'} />Overseas
                                    </label> */}
                                </div>
                        </div>
                           
                            
                        <div className="mb-3 row">
                            <h5 className="col-sm-12">e-Invoice Details</h5>
                        </div>
                        <hr></hr>

                         <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">Require e-Invoice? <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <Select
                                    styles={{
                                        control: provided => ({ ...provided, borderRadius: "2rem" })
                                    }}
                                    required
                                    placeholder="Select e-Invoice indicator"
                                    value={einvoiceIndicatorList.find(obj => obj.label === requireEinvoice)}
                                    options={einvoiceIndicatorList}
                                    onChange={(e) => { updateEinvoiceIndicator(e.label); }}
                                    
                                />
                            </div>
                        </div> 

                        <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">
                                TIN No.
                                {requireEinvoice == 'Yes' ?
                                    <span className='text-danger'>*</span>
                                :
                                    ""
                                }    
                            </label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control" value={tinNo} maxLength={14} onChange={(e) => setTinNo(e.target.value)} 
                                 disabled={(requireEinvoice == 'No')
                                    ? 
                                    'disabled'  : ''} />
                            </div>
                        </div>
                           
                        </div>
                    </div>

                    <div className="mb-3 row mt-5 align-items-center">
                    <div className='col-6'>
                        <Button type="button" variant="info" className="me-3" onClick={() => { props.setKey('plan') }}>Back</Button>
                        </div>
                        <div className="col-6 text-end">
                            <Button type="submit">Continue</Button>
                            {/*
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                            */}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Summary(props) {
    let query = new URLSearchParams(useLocation().search);
    const [transactionData, setTransactionData] = useState([]);
    const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000));
    const [isGetSummary, setIsGetSummary] = useState(false);
    const [onSave, setOnSave] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [periodFrom, setPeriodFrom] = useState(new Date());
    const [periodTo, setPeriodTo] = useState(addDays(addYears(new Date(), 1), -1));
    const [agreed, setAgreed] = useState("");
    const currentDate = new Date(); 
    const targetDate = new Date('2024-03-01');
    const shouldShowAlert = currentDate < targetDate;

    const commissionStyle = {
        color: "#899499",
        fontSize: "0.563em",
      };



    useEffect(() => {

        if(!isEmpty(props.renewalInfo) && !isEmpty(props.renewalInfo.expiry_date)) {

            const renewalStartDate = addDays(new Date(props.renewalInfo.expiry_date), 1);

            setPeriodFrom(new Date(renewalStartDate));
            setPeriodTo(new Date(addDays(addYears(renewalStartDate, 1), -1)));
        }

    }, [props.renewalInfo]);


    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.ownerInfo.length !== 0 && props.planInfo.length !== 0) {

          

            setTransactionData({
                //quoteId: props.ownerInfo.quote,
                name: props.ownerInfo.policyName,
                idNo: props.ownerInfo.policyIC,
                contactNo: props.ownerInfo.ownerContactNo,
                emailAdd: props.ownerInfo.ownerEmailAdd,
                gender: props.ownerInfo.policyGender,
                dob: Moment(props.ownerInfo.policyDOB).format('YYYY-MM-DD'),
                occupation: props.ownerInfo.occupation,
                nationality: props.ownerInfo.policyNationality,
                employmentLocation:  props.ownerInfo.employmentLocation,
                address: props.ownerInfo.ownerAddr1,
                insurer: "The Pacific Insurance Berhad",
                product: props.ownerInfo.plan.product,
                planName: props.ownerInfo.plan.planName,
                premium: props.ownerInfo.plan.planPremium,
                //addons: props.addonsInfo.addons,
                serviceTax: props.ownerInfo.plan.planSST,
                stampDuty: props.ownerInfo.plan.planStampDuty,

                //totalPay: props.ownerInfo.plan.planTotalPayable,

                promo: props.ownerInfo.promo,
                promoAmount: props.ownerInfo.promoAmount,
                discountPercentage: props.ownerInfo.discountPercentage,
                grossPay: props.ownerInfo.plan.planTotalPayable,
                totalPay: props.ownerInfo.discountAmount,

               // beforeDis: props.addonsInfo.amount,
                //promo: props.addonsInfo.promo,
                periodFrom: Moment(periodFrom).format('YYYY-MM-DD'),
                periodTo: Moment(periodTo).format('YYYY-MM-DD'),
                TransactionNo: transactionNo,
                referral: props.referral,

                tinNo: props.ownerInfo.tinNo,
                requireEinvoice: props.ownerInfo.requireEinvoice,
                isRenew : !isEmpty(props.renewalInfo) ? 'Y' : 'N',

              
            });

        } else if (query.get("paymentID") !== null) {
            axios.get('/api/order/' + query.get("paymentID"))
                .then(res => {
                    var trans = res.data[0]['trans'];
                   
                    setTransactionData({
                        //quoteId: props.ownerInfo.quote,
                        name: trans.insured_name,
                        idNo: trans.insured_id_number,
                        contactNo: trans.insured_mobile_number,
                        emailAdd: trans.insured_email,
                        gender: trans.insured_gender,
                        dob: Moment(trans.insured_dob).format('YYYY-MM-DD'),
                        occupation: trans.insured_occupation,
                        nationality: trans.insured_nationality,
                        employmentLocation: trans.insured_employment_location,
                        address: trans.insured_address,
                        insurer: trans.insurer,
                        product: trans.product,
                        planName: trans.plan,
                        premium: trans.gross_premium,
                        //addons: props.addonsInfo.addons,
                        serviceTax: trans.service_tax,
                        stampDuty: trans.stamp_duty,
                        totalPay: trans.total_payable,
                        promo: trans.promo_code,
                        promoAmount: trans.discount_amount,
                        discountPercentage: 25,
                        grossPay: trans.gross_payable_amount,

                        periodFrom: Moment(trans.inception_date).format('YYYY-MM-DD'),
                        periodTo: Moment(trans.expiry_date).format('YYYY-MM-DD'),
                        TransactionNo: transactionNo,
                        payment_status: trans.payment_status,
                        txn_message: trans.txn_message,

                        tin_no: trans.tin_no,
                        require_einvoice: trans.requireEinvoice

                    });
                    setIsGetSummary(true);
                })
        }
    }, [props.ownerInfo, props.planInfo]);

    useEffect(() => {
       
        if (onSave && transactionData.length !== 0) {
                setModalShow(false);

            const loadingSwal = Swal.fire({
                title: 'Please Wait...',
                allowOutsideClick: false,
                willOpen: () => {
                    Swal.showLoading();
                },
                showConfirmButton: false // Remove the "OK" button
            });

            axios.post('/api/insert-payment', {
                transaction_type: 'SALE',
                payment_method: 'ANY',
                service_id: serviceID,
                payment_id: transactionNo,
                order_number: transactionNo,
                payment_description: "Personal Cyber Insurance - " + transactionData.name,
                amount: transactionData.totalPay,
                currency_code: currencyCode,
                hash: HashValue.toString()
            }).then(() => {
                
                axios.post('/api/insert-transaction', {
                    transaction_data: transactionData
                })
                .then(function (response) {
                    if (response.data.status) {
                        Swal.close();
                        document.getElementById('details-form').submit();
                    }
                })
                .catch(function (error) {
                    Swal.close();
                    console.log(error);
                });

            });
        }
        
    }, [onSave]);

    let merchantAcc = process.env.MIX_PAYMENT_GATEWAY_PASSWORD;
    let serviceID = process.env.MIX_PAYMENT_GATEWAY_SERVICE_ID;
    let merchantReturnURL = process.env.MIX_APP_URL + "/api/store";
    //let merchantReturnURL = "http://127.0.0.1:8000/api/store";
    let currencyCode = "MYR";
    let ip = process.env.MIX_APP_URL;
    let timeout = "600";
    let HashValue = SHA256(merchantAcc + serviceID + transactionNo + merchantReturnURL + Number(transactionData.totalPay).toFixed(2) + currencyCode + ip + timeout);
            
    function PaymentSuccess() {
        return (<div className="alert alert-success" role="alert">
            {transactionData.txn_message ? transactionData.txn_message: 'Transaction Successful' }
        </div>);
    }

    function PaymentFail() {
        return (<div className="alert alert-danger" role="alert">
            {transactionData.txn_message ? transactionData.txn_message+'. ': 'Payment Failed.' }Please try again.
        </div>);
    }

    function PaymentPending() {
        return (<div className="alert alert-warning" role="alert">
            Your Payment is still Pending.
        </div>);
    }

    function Message() {
        if (transactionData.payment_status == 'Pending') {
            return <PaymentPending />;
        } else if (transactionData.payment_status == 'Payment Accepted') {
            return <PaymentSuccess />;
        } else if (transactionData.payment_status == 'Payment Failure')
            return <PaymentFail />
        else return <></>
    }

    return (
        <div>
            {transactionData.length !== 0 ?
                <Form action={process.env.MIX_PAYMENT_GATEWAY_URL} method="POST" id="details-form">
                    <input type="hidden" name="TransactionType" value="SALE" />
                    <input type="hidden" name="PymtMethod" value="ANY" />
                    {/* <input type="hidden" name="PymtMethod" value="CC" /> */}
                    <input type="hidden" name="ServiceID" value={serviceID} />
                    <input type="hidden" name="PaymentID" value={transactionNo} />
                    <input type="hidden" name="OrderNumber" value={transactionNo} />
                    <input type="hidden" name="PaymentDesc" value="Payment for Personal Cyber Insurance" />
                    <input type="hidden" name="MerchantReturnURL" value={merchantReturnURL} />
                    <input type="hidden" name="Amount" value={Number(transactionData.totalPay).toFixed(2)} />
                    <input type="hidden" name="CurrencyCode" value={currencyCode} />
                    <input type="hidden" name="CustName" value={transactionData.name} />
                    <input type="hidden" name="CustPhone" value={transactionData.contactNo} />
                    <input type="hidden" name="CustEmail" value={transactionData.emailAdd} />
                    <input type="hidden" name="CustIP" value={ip} />
                    <input type="hidden" name="PageTimeout" value={timeout} />
                    <input type="hidden" name="LanguageCode" value="en" />
                    <input type="hidden" name="HashValue" value={HashValue} />
                    <div className="px-3 row">
                        <div className="col-12">
                            <div className="my-2">
                                {isGetSummary ? <Message /> : null}
                            </div>
                            <Card className="my-2">
                                <Card.Header className="text-primary fw-bold">Summary of Policy</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">

                                            <div className="mb-3 row">
                                                <label className="col-4 col-form-label">Insurer</label>
                                                <label className="col-8 col-form-label text-end">{transactionData.insurer}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 col-form-label">Product</label>
                                                <label className="col-8 col-form-label text-end">{transactionData.product}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Plan Name</label>
                                                <label className="col-6 col-form-label text-end">{transactionData.planName}</label>
                                            </div>
                                            
                                             <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Inception Date</label>
                                                <label className="col-6 col-form-label text-end">{transactionData.periodFrom}</label>
                                            </div>

                                             <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Expiry Date</label>
                                                <label className="col-6 col-form-label text-end">{transactionData.periodTo}</label>
                                            </div>
                                           
                                            
                                        </div>
                                        <div id="payment" className="col-md-6">

                                           
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Basic Premium</label>
                                                <label className="col-6 col-form-label text-end">RM {parseFloat(transactionData.premium).toFixed(2)}</label>
                                            </div>
                                            
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Service Tax 8%</label>
                                                <label className="col-6 col-form-label text-end">RM {parseFloat(transactionData.serviceTax).toFixed(2)}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Stamp Duty</label>
                                                <label className="col-6 col-form-label text-end">RM {parseFloat(transactionData.stampDuty).toFixed(2)}</label>
                                            </div>

                                        </div>

                                       
                                    </div>

                                    { !isEmpty(transactionData.promo) ?
                                        <div className="row">
                                            <div className="col-md-6"></div>

                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-7 text-danger">Promo {transactionData.discountPercentage > 0 ? `${transactionData.discountPercentage}% off` : "" } <br></br>({ transactionData.promo })</label>
                                                    <label className="col-5 text-end align-self-center text-danger">
                                            
                                                    - RM {parseFloat(transactionData.promoAmount).toFixed(2)}
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                        :
                                        null
                                    }
                                    
                                </Card.Body>
                                <Card.Footer>
                                    <div className="row fw-bold">
                                        <label className="col-6 col-form-label">Total Amount Payable</label>
                                        <label className="col-6 col-form-label text-end">
                                            RM {parseFloat(transactionData.totalPay).toFixed(2)} 
                                        </label>
                                         {/* {isEmpty(transactionData.promo) ? 
                                                <label className="col-6 col-form-label text-end">
                                                   RM {parseFloat(transactionData.totalPay).toFixed(2)}
                                                </label>
                                                :
                                                <label className="col-6 col-form-label text-end">
                                                    <span className='h5 text-primary fw-bold'> RM {parseFloat(transactionData.totalPay).toFixed(2)}</span> <br></br>
                                                    <span style={{ textDecoration: 'line-through' }}>  RM {parseFloat(transactionData.grossPay).toFixed(2)}</span>
                                                </label>
                                            } */}
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div style={commissionStyle}>{process.env.MIX_COMMISION_RATE}% of commission amounting to RM {( parseFloat(transactionData.premium) * (parseFloat(process.env.MIX_COMMISION_RATE)/100)).toFixed(2)} is payable to intermediary.</div>
                                        </div>
                                    </div>
                                </Card.Footer>
                            </Card>
                            <Card>
                                <Card.Header className="text-primary fw-bold">Insured Details</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Full Name</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.name}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">NRIC / Passport No.</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.idNo}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Gender</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.gender}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Date Of Birth</label>
                                                <label className="col-6 col-form-label text-end text-primary">{Moment(transactionData.dob).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Contact Number</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.contactNo}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 col-md-3 col-form-label">Email</label>
                                                <label className="col-8 col-md-9 col-form-label text-end text-primary">{transactionData.emailAdd}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-4 col-form-label">Address</label>
                                                <label className="col-8 col-form-label text-end text-primary">{transactionData.address}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Employment Location</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.employmentLocation}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-md-5 col-form-label">Occupation</label>
                                                <label className="col-6 col-md-7 col-form-label text-end text-primary">{transactionData.occupation}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>

                            <div className="mb-3 row mt-5 align-items-center">
                                <div className='col-lg-12'>
                                    {shouldShowAlert && (
                                        <div className="alert alert-danger" role="alert">
                                            Disclaimer: As announced by the government in the Budget 2024, <b>effective from 1st March 2024</b>, the adjustment of service tax from <b>6% to 8%</b> is applicable to all insurance services. Please be informed that any modifications or augmentation in service tax attributable to this revision is the responsibility of the insurance policy holder. The additional payable service tax is also applicable to any policy that is procured before 1st March 2024 but with a period of insurance spanning across 1st March 2024. Therefore, Howden Insurance Brokers Sdn Bhd reserves the right to collect any additional service tax on behalf of the Royal Malaysian Customs Department.
                                        </div>
                                    )}
                                </div>
                                <div className='col-6'>
                                <Button type="button" variant="info" className="me-3" onClick={() => { props.setKey('owner') }}>Back</Button>
                                </div>
                                <div className="col-6 text-end">
                                <Button type="button" variant="success" className="mb-3 mt-3"  onClick={() => setModalShow(true)}>Pay Now</Button>
                                </div>
                            </div>


                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} name={transactionData.name} age={transactionData.age} policy={transactionData.policyName} setOnSave={setOnSave} />
                        </div>
                    </div>
                </Form>
                :
                <div className="text-center">
                    <br />
                    <img src="../images/loading.gif" />
                    <br />
                    Please wait
                    <br />
                </div>
            }
        </div >
    );

}

function PromptConfirmation(props) {
    const [agreed, setAgreed] = useState(null);
    const [checkbox1, setCheckbox1] = useState(false);
    const [checkbox2, setCheckbox2] = useState(false);

    // const useAnalyticsEventTracker = (category = "Instapol - GA4 category") => {
    //     const eventTracker = (action = "test action", label = "test label") => {
    //         ReactGA.event({ category, action, label });
    //     }
    //     return eventTracker;
    // }
    // const gaEventTracker = useAnalyticsEventTracker('Payment');

  
    const handleCheckbox1Change = (e) => {
        setCheckbox1(e.target.checked);
    };

    const handleCheckbox2Change = (e) => {
        setCheckbox2(e.target.checked);
    };

    useEffect(() => {

        if(checkbox1 && checkbox2)
        {
            setAgreed(true);

        } else {

            setAgreed(false);

        }   
    }, [checkbox1, checkbox2]);


    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header >
                <Modal.Title>Confirmation</Modal.Title>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.onHide}></button>

            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-justify">
                        <div className="col-12">I, <span className="text-primary">{props.age < 18 ? props.policy : props.name}</span>, confirmed that:</div>
                        
                        <div className="row mt-3 ms-1">
                            
                            <div className="col-1">
                                <input
                                    type="checkbox"
                                    name="checkbox1"
                                    value="Yes"
                                    checked={checkbox1}
                                    onChange={handleCheckbox1Change}
                                    style={{ transform: 'scale(2.0)', marginRight: '0px' }} 
                                /> 
                            </div>
                            <div className="col-11">
                                
                                        I understand that it is my duty to take reasonable care not to make a misrepresentation in answering the questions and hereby declare that I have fully and accurately answered the questions in this Application.
                                
                              
                            </div>  
                        </div>

                        <div className="row mt-3 ms-1">
                            <div className="col-1">
                                <input
                                        type="checkbox"
                                        name="checkbox1"
                                        value="Yes"
                                        checked={checkbox2}
                                        onChange={handleCheckbox2Change}
                                        style={{ transform: 'scale(2.0)', marginRight: '0px' }} 
                                    /> 
                            </div>

                            <div className="col-11">
                                
                                    I have read, understood and accepted the <a href="storage/pdf/pds.pdf" target="_blank" className="text-decoration-none">Product Disclosure Sheet</a>, <a href="storage/pdf/pw.pdf" target="_blank" className="text-decoration-none">Policy Wording</a> and
                                    <a href="https://www.howdengroup.com/my-en/privacy-and-data-protection" className="text-blue text-decoration-none" target="_blank"> Privacy Policy</a> for this product.
                                
                            </div>

                        </div>

                        <div className="row text-center mt-4">
                            {/* <div className="col-12">
                                <input type="radio" value="true" name="disclosure" onChange={() => setAgreed(true)} /> Agree
                                <input className="ms-4" type="radio" value="false" name="disclosure" onChange={() => setAgreed(false)} /> Disagree
                            </div> */}
                            {(agreed === false) ?
                                <div className="col-12 text-danger">You have to agree to our terms in order to complete the transaction.</div>
                                : ''
                            }
                        </div>
                        <div className="col-12 mt-4">
                            <strong>
                                Please make sure you review the order and personal details before payment page. Once you click 'Pay Now' you cannot
                                change these details.
                            </strong>
                        </div>
                        <div className="col-12 mt-4">
                            In the event that your proposal does not meet the requirement of Anti Money Laundering and Sanction screening, this confirmation will be void <span className="font-italic">ab initio</span> and your premium will be refunded accordingly by Howden Insurance Brokers Sdn Bhd.
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="row text-end">
                    <div className="col-5">
                        <Button type="button" variant="secondary" onClick={props.onHide}>Cancel</Button>
                    </div>
                    <div className="col-7">
                        <Button type="button" variant="success" form="details-form" disabled={isNull(agreed) || agreed === false ? 'disabled' : ''} onClick={(e) => { props.setOnSave(true)}}>Pay Now</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
